import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CONFIG } from '@config';
import { GridContainerComponent } from '../grid-container/grid-container.component';
import { ImageComponent } from '../image/image.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [GridContainerComponent, ImageComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class HeaderComponent {
  readonly assetsPath = inject(CONFIG).assetsPath;

  scrollToMainContent(): void {
    const mainContent: HTMLElement | null = document.getElementById('main');

    if (mainContent) {
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
